import script from "./AgentCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentCreate.vue?vue&type=script&setup=true&lang=js"

import "./AgentCreate.vue?vue&type=style&index=0&id=1d70d39e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d70d39e"]])

export default __exports__